export default __webpack_public_path__ + "static/media/2.4e542a7c.jpg";